<template>
    <div class="w-100 lm-border pa-3" style="height: 200px; position: relative;">
        <div class="no-frame">
                <c-site-tzb-title
                    :title="$t('unit.tzb.title')"
                    :rating="data.rating"
                    :padding-right="0"
                />

            <v-row class="no-frame">
                <v-col class="no-frame pr-2 col-6">
                    <f-read-only-field
                        :value = "data.assessor"
                        :label = "$t('unit.tzb.assessor')"
                        class  = "w-100"
                        :line  = "false"
                        dense
                    />
                </v-col>
                <v-col class="no-frame pl-2 col-6">
                    <f-read-only-field
                        :value = "inspection"
                        :label = "$t('unit.tzb.inspection')"
                        class  = "w-100"
                        :line  = "false"
                        dense
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame">
                <div class="w-100 mt-2" style="overflow-y: scroll; max-height: 95px" v-if="readonly">
                    <div class="ma-0" v-html="htmlNote" >
                    </div>
                </div>
                <div class="w-100 mt-0"  v-if="!readonly">
                    <v-textarea
                        v-model="data.note"
                        class="pt-2"
                        rows="3"
                        no-resize
                    />
                </div>
            </v-row>
        </div>
    </div>
</template>

<script>


import Core           from "@/modules/core/service/Core";
import CSiteTzbTitle  from "@/modules/msd/unit/components/dialog/CSiteTzbTitle";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";

export default {
    name: "CSiteTzbElevatorGeneral",

    components: {
        FReadOnlyField,
        CSiteTzbTitle
    },

    props: {
        data: {
        },

        readonly: {

        }
    },

    data: () => ({
        flipped: false,
        edit   : false,
    }),

    computed: {
        inspection () {
            return Core.format.date.display(this.data.date)
        },

        htmlNote () {
            if (!this.data.note) {
                return null;
            }

            return this.data.note.replaceAll ("\n", "<br>");
        }
    },

    watch: {
        data () {
            this.edit = false;
        }
    },

    methods: {
        onEdit () {
            this.edit  = !this.edit;
        }
    }
}
</script>
